export default __webpack_public_path__ + "static/media/sbo-img.1db0a895.webp";